/*!
 * iwebsite-glide-slider.js — safe-init v1.0
 * Работает даже когда CDN Glide грузится позже. Отдаёт приоритет уже смонтированным темой слайдерам.
 * Last JS update: 2026-01-25 14:30
 */
(function () {
  "use strict";

  var VERSION  = "safe-init v1.0";
  var SELECTOR = ".banner-glide-slider, .related-products-slider";

  var instances = new Map();   // el -> glideInstance
  var TRACE = false, MARK = false;
  var bootLogged = false;

  // ---------- tiny logger ----------
  function log(){ if (TRACE) console.log.apply(console, ["[IWGLIDE]"].concat([].slice.call(arguments))); }
  function warn(){ console.warn.apply(console, ["[IWGLIDE]"].concat([].slice.call(arguments))); }

  // ---------- helpers ----------
  function $all(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }
  function hasStructure(el){
    return !!el.querySelector(":scope > .glide__track") &&
           !!el.querySelector(":scope > .glide__track > .glide__slides");
  }
  function alreadyMountedByTheme(el){
    var list = el.querySelector(":scope > .glide__track > .glide__slides");
    if (!list) return false;
    return el.classList.contains("glide--swipeable") || list.querySelector(".glide__slide--clone") != null;
  }
  function countOriginalSlides(el){
    var list = el.querySelector(":scope > .glide__track > .glide__slides");
    if (!list) return 0;
    return Array.from(list.children).filter(li => !li.classList.contains("glide__slide--clone")).length;
  }
  function perViewFor(el){
    var d = parseInt(el.getAttribute("data-desktop-slide")) || 3;
    var t = parseInt(el.getAttribute("data-tablet-slide"))  || 2;
    var m = parseInt(el.getAttribute("data-mobile-slide"))  || 1;
    var w = window.innerWidth;
    if (w <= 480) return m;
    if (w <  768) return t;
    return d;
  }
  function dir(){ return (document.documentElement.getAttribute("dir")||"ltr").toLowerCase(); }

  // ---------- debug marks ----------
  function mark(el, text){
    if (!MARK) return;
    try{
      if (getComputedStyle(el).position === "static") el.style.position = "relative";
      el.style.outline = "2px dashed #3b82f6";
      var b = el.querySelector(":scope > .iwg-badge");
      if (!b){ b = document.createElement("div"); b.className = "iwg-badge"; el.appendChild(b); }
      b.textContent = text;
      b.style.cssText = "position:absolute;top:2px;left:2px;z-index:9;font:12px/1 monospace;background:rgba(0,0,0,.6);color:#fff;padding:2px 4px;border-radius:3px;pointer-events:none;";
    }catch(e){}
  }
  function unmark(el){
    el.style.outline = "";
    var b = el.querySelector(":scope > .iwg-badge");
    if (b && b.parentNode) b.parentNode.removeChild(b);
  }

  // ---------- core ----------
  function mountOne(el){
    if (!hasStructure(el)){ mark(el, "no-structure"); log("skip(no-structure)", el.id||el); return; }

    // если тема уже смонтировала — мы не трогаем
    if (alreadyMountedByTheme(el)){
      if (instances.has(el)){ try{ instances.get(el).destroy(); }catch(e){} instances.delete(el); }
      mark(el, "external");
      log("external controls slider → opt-out", el.id||el);
      return;
    }

    var total = countOriginalSlides(el);
    var pv    = perViewFor(el);

    if (total <= pv){
      if (instances.has(el)){ try{ instances.get(el).destroy(); }catch(e){} instances.delete(el); }
      el.classList.add("glide--disabled");
      mark(el, "disabled");
      log("disabled (slides<=perView)", { id: el.id||el, total, pv });
      return;
    }

    if (instances.has(el)){ try{ instances.get(el).destroy(); }catch(e){} instances.delete(el); }

    var d = dir();
    var glide = new Glide(el, {
      type: "carousel",
      perView: pv,
      direction: d,
      gap: 5,
      bound: true,
      autoplay: 4000,
      hoverpause: true,
      animationDuration: 2000,
      animationTimingFunc: "ease-in-out",
      breakpoints: {
        768: { perView: parseInt(el.getAttribute("data-tablet-slide")) || 2 },
        480: { perView: parseInt(el.getAttribute("data-mobile-slide")) || 1 }
      }
    });

    try{
      glide.mount();
      instances.set(el, glide);
      el.classList.remove("glide--disabled");
      mark(el, "mounted");
      var clones = el.querySelectorAll(".glide__slide--clone").length;
      log("mounted", { id: el.id||el, pv, slides: total, clones, dir: d });
    }catch(e){
      warn("mount error", el.id||el, e);
      el.classList.add("glide--disabled");
      mark(el, "error");
    }
  }

  function scanAndMountAll(){
    if (!bootLogged){
      // IWGLIDE boot - Last JS update: 2026-01-25 12:00
      bootLogged = true;
    }
    var els = $all(SELECTOR);
    if (!els.length){ log("no targets yet"); return; }

    // если Glide ещё не приехал — не падаем, просто сообщаем
    if (!(window.Glide && typeof window.Glide === "function")){
      log("Glide not ready yet");
      return;
    }

    els.forEach(mountOne);
  }

  // retry-петля: ждём Glide и DOM до 6 сек
  function startWithRetry(){
    var tries = 0;
    var timer = setInterval(function(){
      tries++;
      scanAndMountAll();
      if (window.Glide && typeof window.Glide === "function" && instances.size > 0){
        clearInterval(timer);
        log("ready (instances:", instances.size, ")");
      }
      if (tries > 50){ // ~6 сек
        clearInterval(timer);
        log("stop retry (timeout)");
      }
    }, 120);
  }

  // реагируем на ресайз
  function onResize(){
    $all(SELECTOR).forEach(function(el){
      // не трогаем внешние
      if (alreadyMountedByTheme(el)) return;
      if (instances.has(el)) mountOne(el); else mountOne(el);
    });
  }

  // MutationObserver — монтируем только когда целевые узлы реально появились
  var mo = new MutationObserver(function(list){
    var need = false;
    for (var i=0;i<list.length;i++){
      var m = list[i];
      if (!m.addedNodes) continue;
      for (var j=0;j<m.addedNodes.length;j++){
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches(SELECTOR)) { need = true; break; }
        if (n.querySelector && n.querySelector(SELECTOR)) { need = true; break; }
      }
      if (need) break;
    }
    if (need) scanAndMountAll();
  });

  function bootstrap(){
    startWithRetry();
    window.addEventListener("resize", onResize, { passive: true });
    ["shopify:section:load","shopify:section:reorder","shopify:section:select","shopify:section:deselect"]
      .forEach(function(evt){ document.addEventListener(evt, scanAndMountAll); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "complete") bootstrap();
  else { window.addEventListener("load", bootstrap, { once: true }); }

  // ---------- public debug ----------
  window.IWDBG = {
    version: VERSION,
    trace: function(on){ TRACE = !!on; return TRACE; },
    mark: function(on){
      MARK = !!on;
      if (!MARK) document.querySelectorAll(".iwg-badge").forEach(function(b){ b.remove(); });
      scanAndMountAll(); // обновим подписи
      return MARK;
    },
    dump: function(){
      var rows = [];
      $all(SELECTOR).forEach(function(el,i){
        var list = el.querySelector(":scope > .glide__track > .glide__slides");
        rows.push({
          i,
          id: el.id || "(no-id)",
          external: alreadyMountedByTheme(el),
          perView: perViewFor(el),
          slides: countOriginalSlides(el),
          clones: list ? list.querySelectorAll(".glide__slide--clone").length : 0,
          hasInstance: instances.has(el)
        });
      });
      if (rows.length){ try{ console.table(rows); }catch(e){ console.log(rows); } } else { console.log("[]"); }
      return rows;
    },
    inspect: function(i){
      var el = $all(SELECTOR)[i];
      if (!el){ warn("inspect: element not found"); return null; }
      var list = el.querySelector(":scope > .glide__track > .glide__slides");
      var info = {
        id: el.id || "(no-id)",
        external: alreadyMountedByTheme(el),
        dir: dir(),
        perView: perViewFor(el),
        slides: countOriginalSlides(el),
        clones: list ? list.querySelectorAll(".glide__slide--clone").length : 0,
        hasInstance: instances.has(el)
      };
      console.log("[IWDBG.inspect]", info);
      return info;
    }
  };
})();

(function () {
  var SELECTOR = '.banner-glide-slider';

  function markReady(el) {
    if (!el || el.classList.contains('iw-fade-ready')) return;
    var ready = el.classList.contains('glide--swipeable') ||
                el.querySelector('.glide__slide--clone');
    if (ready) el.classList.add('iw-fade-ready');
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(markReady);
  }

  // 1) Первый проход
  scan();

  // 2) Когда страница догрузилась
  window.addEventListener('load', scan, { once:true });

  // 3) Отслеживаем появление классов/клонов от Glide
  var mo = new MutationObserver(function() { scan(); });
  mo.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();


